import React from "react";
import { DataStore } from "@aws-amplify/datastore";
import { Member } from "../models";
import { useSelector } from "react-redux";
import { selectChapter } from "../features/chapter/slice";
import {
  selectMember,
  selectUserEmail,
  selectUserSubId,
} from "../features/member/slice";
import Form from "../Component/Form";
import PageNavBar from "../Component/page/PageNavBar";
import { useNavigate } from "react-router-dom";
import { withAuthenticator } from "@aws-amplify/ui-react";

function SignUp() {
  const chapter = useSelector(selectChapter);
  const member = useSelector(selectMember);
  const userEmail = useSelector(selectUserEmail);
  const userSubId = useSelector(selectUserSubId);
  const chapterExist = !!chapter;
  const signUpOpen = !!chapter?.signUpOpen;
  const displaySignUpForm = chapterExist && !member && signUpOpen;
  const navigate = useNavigate();

  async function addMember(formData) {
    try {
      if (!userSubId) {
        throw Error("Can't generate new member ID while adding a member.");
      }
      const studentData = {
        ...formData,
        id: userSubId,
        chapterID: chapter.id,
        email: userEmail,
      };
      await DataStore.save(new Member(studentData));
      navigate("/");
    } catch (err) {
      console.error("error creating student:", err);
    }
  }

  return (
    <>
      <div>
        <PageNavBar />
        {displaySignUpForm && (
          <Form
            year={chapter.year}
            semester={`${chapter.semester}`}
            submitHandler={addMember}
          />
        )}

        {!signUpOpen && !member && (
          <div>
            <h1>member signup form is currently closed.</h1>
            <p>Please contact an AGS officer if you think this is a mistake</p>
          </div>
        )}
        {!!member && (
          <div>
            <h1>You already are an AGS member</h1>
            <p>Please contact an AGS officer if you think this is a mistake</p>
          </div>
        )}
      </div>
    </>
  );
}

export default withAuthenticator(SignUp);
//!member should say member already exist
// const displayFormClosedError = !!chapter && !member && !signUpOpen;
